const download = () => {
  window.open(
    `https://drive.google.com/file/d/1CCL_hJJVHAYq3wQhsrQ5Uv_dxhJSkjM-/view?usp=sharing`,
  );
};

export default download;
